import type { AnalyticsEvent, AnalyticsEventInput } from '../events';

import { filterNullishProperties } from './filterUndefinedEventPropertiesInput';
import { getApplicationContextInput } from './getApplicationContextInput';
import { getAnalyticsEventInput } from './getTelemetryEventInput';

type GetAnalyticsEventInputWithContext = (event: AnalyticsEvent) => AnalyticsEventInput;
const getAnalyticsEventInputWithContext: GetAnalyticsEventInputWithContext = (event) => {
  const analyticsEventInput = getAnalyticsEventInput(event);

  return {
    name: analyticsEventInput.name,
    properties: filterNullishProperties({ ...analyticsEventInput.properties, ...getApplicationContextInput() }),
  };
};

type GetReportAnalyticsEventsInput = (analyticsEvents: AnalyticsEvent[]) => AnalyticsEventInput[];
export const getReportAnalyticsEventsInput: GetReportAnalyticsEventsInput = (analyticsEvents) =>
  analyticsEvents.map((event) => getAnalyticsEventInputWithContext(event));
